module.exports = __webpack_public_path__ + "static/media/hero-desktop.70584ff3.jpg";